import React from 'react';
import { Spinner } from 'react-bootstrap';
import CameraView from './CameraViewWS';
import { getCameraViews, isCameraLoading, hasCameraLoaded } from '@awp/stores/cameraViewsSlice';
import { useSelector } from 'react-redux';

const WeatherStationCameraView = () => {
  const cameraViews = useSelector(getCameraViews);
  const loading = useSelector(isCameraLoading);
  const loaded = useSelector(hasCameraLoaded);

  return (
    <div className="card mb-5">
      <div className="card-header">
        <div className="d-flex">
          <h4 className="flex-grow-1 mb-0">Camera Views</h4>
        </div>
      </div>
      <div className="card-body">
        <div>
          <div className="row" style={{ marginLeft: '0px' }}>
            {loading && (
              <div className="text-center">
                <Spinner animation="border" size="sm" />
              </div>
            )}
            {loaded && cameraViews.length == 0 && <div className="text-center .display-4">No cameras found</div>}
            {loaded && cameraViews.length > 0 && cameraViews.map((cv, key) => <CameraView key={key} CameraView={cv} />)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeatherStationCameraView;
